export enum  AcceptableEnum{
    NO = 'NO',
    YES = 'YES',
    REJECT = 'REJECT',
}